/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2020] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Marionette = require('backbone.marionette');
var SideNavSectionView = require('common/views/SideNavSectionView');

var LicenseContactsSectionView = require('../../new-license/views/LicenseContactsSectionView');
var tmplNonDepNMLSLicenseApplicationView = require('../templates/NonDepNMLSLicenseApplicationView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplNonDepNMLSLicenseApplicationView,

  className: 'non-dep-nmls-license-application-view',

  behaviors: {
    ReadOnlyFormBehavior: {}
  },

  ui: {
    NMLSApplicationWrapper: '.nmls-application'
  },

  regions: {
    NMLSApplicationWrapper: '@ui.NMLSApplicationWrapper'
  },

  onBeforeShow: function() {
    var application = this.model.get('applicationDetails');
    var mode = this.options.mode;
    var isForPrinting = mode === 'print';
    var isExpandInternal = mode === 'int-expand';
    this.form = new SideNavSectionView({
      collection: new Backbone.Collection([
        {
          id: 'contacts',
          title: 'Contacts',
          view: new LicenseContactsSectionView({
            isReadOnly: true,
            model: new Backbone.Model({
              licenseContactTypes: this.model.get('licenseContactTypes'),
              requiredContactTypes: null,
              contacts: this.model.get('contacts'),
              applicationId: application.applicationId,
              existingContacts: null
            })
          })
        }
      ]),
      expanded: isForPrinting || isExpandInternal
    });

    this.showChildView('NMLSApplicationWrapper', this.form);
  }
});
